import {Component, Input} from '@angular/core';


export class RpOptionComponent {
   label;
   value;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'rp-option',
  template: ``,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'label': [{ type: Input },],
'value': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
